module finadai.app.admin.find {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.find"

    function AdminFindController(customersService: services.CustomersService,
                                 whoIAm: models.User, $rootScope, $scope,
                                 notify, confirm, $mdDialog: ng.material.IDialogService,
                                 $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                 proxifier, $q: ng.IQService, authService: services.AuthService) {
        $scope.formData = {};
        $scope.searchingInProgress = false;
        $scope.searchComplete = false;
        $scope.messageCustomer = "";
        $scope.customer_number = 0;
        let msgCustomer = "";
        $scope.canFindCustomer = whoIAm.operations.indexOf('admin_find_customer') >= 0;
        $scope.otorgantes = [];
        customersService.proxyGetOriginator().then(response => {
            const otorgantes = response.data.Data.Originadores;
            otorgantes.forEach(o => {
                $scope.otorgantes.push({id: o.Originador, name: o.OriginadorNombre});
            });
        });
        $scope.findCustomerData = (form) => {
            $scope.customer_number = null;
            if (form.$valid) {
                $scope.searchComplete = false;
                $scope.searchingInProgress = true;
                $scope.formData.originator_id = $scope.formData.originator.id;
                customersService.proxySearch($scope.formData).then(response => {
                    if (angular.isArray(response.data.Data.Saldo)) {
                        const saldos = <models.proxy.Saldo[]>response.data.Data.Saldo;
                        saldos.forEach(s => {
                            $scope.customer_number = s.NumCliente;
                        })
                    } else {
                        const saldo = <models.proxy.Saldo>response.data.Data.Saldo;
                        $scope.customer_number = saldo.NumCliente;
                    }
                }, function (response) {
                    console.log(response);
                    notify('No se encontraron datos en la busqueda', 'danger');
                    $scope.searchingInProgress = false;
                }).then(function () {
                    if ($scope.customer_number !== null) {
                        customersService.proxyGetCustomer({customer_number: $scope.customer_number}).then(function (response) {
                            $scope.searchingInProgress = false;
                            notify('Acreditado encontrado');
                            $scope.search_customer = response.data;
                            if ($scope.search_customer.Data.PrimerNombre !== undefined) {
                                msgCustomer = "Número de Cliente: " + $scope.customer_number + " <br />RFC: " + $scope.search_customer.Data.RFC + " <br />Nombre Completo: " + $scope.search_customer.Data.PrimerNombre + " " + $scope.search_customer.Data.ApellidoPaterno + " " + $scope.search_customer.Data.ApellidoMaterno;
                                msgCustomer += "<hr />";
                            } else {
                                msgCustomer = "No se encontro acreditado";
                            }
                            $scope.messageCustomer = msgCustomer;
                            $scope.searchComplete = true;
                            this.findCreditForm.reset();
                        }, function (response) {
                            console.log(response);
                            notify('Fallo la busqueda', 'danger');
                            $scope.searchingInProgress = false;
                        });
                    }
                }, function (response) {
                    console.log(response);
                    notify('Fallo la busqueda', 'danger');
                    $scope.searchingInProgress = false;
                });
                /*customersService.proxyGetCustomer({customer_number: $scope.formData.customer_number})
                    .then(function (response) {
                        $scope.search_customer = response.data;
                        if ($scope.search_customer.Data.PrimerNombre !== undefined) {
                            msgCustomer = "Nombre Completo: " + $scope.search_customer.Data.PrimerNombre + " " + $scope.search_customer.Data.ApellidoPaterno + " " + $scope.search_customer.Data.ApellidoMaterno;
                            msgCustomer += "<hr />";
                        } else {
                            msgCustomer = "No se encontro acreditado";
                        }
                    }, function () {

                        notify('Fallo la busqueda', 'danger');
                        $scope.searchingInProgress = false;
                    }).then(function () {
                    customersService.proxySearchCredit({customer_number: $scope.formData.customer_number}).then(function (response) {
                        let $credit_info = "";
                        $scope.search_creditInfo = response.data;
                        $scope.search_creditInfo = angular.isArray($scope.search_creditInfo.Data.Saldo) ? $scope.search_creditInfo.Data.Saldo : [$scope.search_creditInfo.Data.Saldo];
                        angular.forEach($scope.search_creditInfo, function (value, key) {
                            $credit_info += $scope.displayFields(value);
                        });
                        msgCustomer += $credit_info;
                        $scope.messageCustomer = msgCustomer;
                        $scope.searchComplete = true;
                        $scope.searchingInProgress = false;
                    }, function () {
                        $scope.searchComplete = true;
                    });
                })*/
            }
        };
        $scope.displayFields = (value) => {
            var output = '<ul>';
            angular.forEach(value, (value, key) => {
                output += '<li>' + key + ": " + value + '</li>';
            });
            output += '</ul>';
            output += '<hr />';
            return output
        }
    }

    export function run() {
        var find = angular.module(NAME, [])
        find.controller("AdminFindController", AdminFindController)
    }
}
finadai.app.admin.find.run();